import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TRANSLATE_PREFIX, trackingLinkKeyFromMacro } from '../../consts';
import Input from '../Input';
import css from './ParameterKeyCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;

const isNetworkEqualsMacro = macro => /^\{NETWORK=[^{}]+\}$/.test(macro || '');

// `{x=<placeholder>}` style macros (e.g. {IS_ASSIST=<placeholder>}) hint at `x`.
const NETWORK_MATCH_MACRO_PATTERN = /^\{([^={}]+)=[^{}]+\}$/;

const networkMatchKeyFromMacro = macro => {
    const match = NETWORK_MATCH_MACRO_PATTERN.exec(macro || '');
    return match ? match[1].toLowerCase() : null;
};

const placeholderKeyFromMacro = macro => {
    if (isNetworkEqualsMacro(macro)) return 'is_attributed';
    return trackingLinkKeyFromMacro(macro) || networkMatchKeyFromMacro(macro) || macro.slice(1, -1).toLowerCase();
};

const ParameterKeyCell = ({ row, onChange, readOnly, translate }) => {
    const { duplicateKey } = row;
    const errorMessage =
        !readOnly && row.paramErrorKey ? translate(`${TRANSLATE_PREFIX}.ERRORS.${row.paramErrorKey}`) : null;
    return (
        <td>
            <div className={css.cellWrapper}>
                <Input
                    value={row.partner_parameter_key || ''}
                    placeholder={
                        readOnly
                            ? undefined
                            : translate(`${TAB_PREFIX}.PARAMETER_KEY_PLACEHOLDER`, {
                                  key: placeholderKeyFromMacro(row.singular_macro),
                              })
                    }
                    onChange={val => onChange(row.singular_macro, val)}
                    disabled={readOnly}
                    required={!readOnly}
                    error={errorMessage}
                    inputClassName={classNames({ [css.invalidInput]: duplicateKey })}
                    containerClass={css.keyInput}
                />
                {duplicateKey && (
                    <span className={css.duplicateHint}>{translate(`${TAB_PREFIX}.DUPLICATE_KEY_HINT`)}</span>
                )}
            </div>
        </td>
    );
};

ParameterKeyCell.propTypes = {
    row: PropTypes.shape({
        singular_macro: PropTypes.string.isRequired,
        partner_parameter_key: PropTypes.string,
        isDefault: PropTypes.bool,
        paramErrorKey: PropTypes.string,
        duplicateKey: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default ParameterKeyCell;
